import { render, staticRenderFns } from "./RoomNameEditor.vue?vue&type=template&id=57c210f6"
import script from "./RoomNameEditor.vue?vue&type=script&lang=ts"
export * from "./RoomNameEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports